import styled from 'styled-components'

export const ToggleLanguageWrapper = styled.div`
  img {
    cursor: pointer;
  }
`